import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { navigationObservable } from 'helpers/navigationSubjectHelper'
import useNav from 'components/RouteService/useNav'

//to subscribe the navigation subject help on navigating
const NavigationProvider = () => {
  const navigate = useNavigate()
  const { navBack, navTo } = useNav()

  useEffect(() => {
    navigationObservable().subscribe(x => {
      if (x) {
        navTo(x)
      }
    })
  }, [])
  return <></>
}
export default NavigationProvider
